/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const FETCH_ENTITIES_START = 'FETCH_ENTITIES_START';
export const FETCH_ENTITIES_SUCCESS = 'FETCH_ENTITIES_SUCCESS';
export const FETCH_ENTITIES_ERROR = 'FETCH_ENTITIES_ERROR';

export const FETCH_MORE_ENTITIES_START = 'FETCH_MORE_ENTITIES_START';
export const FETCH_MORE_ENTITIES_SUCCESS = 'FETCH_MORE_ENTITIES_SUCCESS';
export const FETCH_MORE_ENTITIES_ERROR = 'FETCH_MORE_ENTITIES_ERROR';

export const FILTER_ENTITIES_START = 'FILTER_ENTITIES_START';
export const FILTER_ENTITIES_SUCCESS = 'FILTER_ENTITIES_SUCCESS';
export const FILTER_ENTITIES_ERROR = 'FILTER_ENTITIES_ERROR';

export const CREATE_ENTITY_START = 'CREATE_ENTITY_START';
export const CREATE_ENTITY_SUCCESS = 'CREATE_ENTITY_SUCCESS';
export const CREATE_ENTITY_ERROR = 'CREATE_ENTITY_ERROR';

export const CREATE_VALUE_START = 'CREATE_VALUE_START';
export const CREATE_VALUE_SUCCESS = 'CREATE_VALUE_SUCCESS';
export const CREATE_VALUE_ERROR = 'CREATE_VALUE_ERROR';

export const UPDATE_ENTITY_START = 'UPDATE_ENTITY_START';
export const UPDATE_ENTITY_SUCCESS = 'UPDATE_ENTITY_SUCCESS';
export const UPDATE_ENTITY_ERROR = 'UPDATE_ENTITY_ERROR';

export const UPDATE_VALUE_START = 'UPDATE_VALUE_START';
export const UPDATE_VALUE_SUCCESS = 'UPDATE_VALUE_SUCCESS';
export const UPDATE_VALUE_ERROR = 'UPDATE_VALUE_ERROR';

export const DELETE_ENTITY_START = 'DELETE_ENTITY_START';
export const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS';
export const DELETE_ENTITY_ERROR = 'DELETE_ENTITY_ERROR';

export const DELETE_ENTITIES_START = 'DELETE_ENTITIES_START';
export const DELETE_ENTITIES_SUCCESS = 'DELETE_ENTITIES_SUCCESS';
export const DELETE_ENTITIES_ERROR = 'DELETE_ENTITIES_ERROR';

export const DELETE_ALL_ENTITIES_START = 'DELETE_ALL_ENTITIES_START';
export const DELETE_ALL_ENTITIES_SUCCESS = 'DELETE_ALL_ENTITIES_SUCCESS';
export const DELETE_ALL_ENTITIES_ERROR = 'DELETE_ALL_ENTITIES_ERROR';

export const REPLACE_ENTITIES_START = 'REPLACE_ENTITIES_START';
export const REPLACE_ENTITIES_SUCCESS = 'REPLACE_ENTITIES_SUCCESS';
export const REPLACE_ENTITIES_ERROR = 'REPLACE_ENTITIES_ERROR';

export const IMPORT_ENTITIES_START = 'IMPORT_ENTITIES_START';
export const IMPORT_ENTITIES_SUCCESS = 'IMPORT_ENTITIES_SUCCESS';
export const IMPORT_ENTITIES_ERROR = 'IMPORT_ENTITIES_ERROR';

export const EXPORT_ENTITIES = 'EXPORT_ENTITIES';

export const DELETE_ENTITY_VALUES_START = 'DELETE_ENTITY_VALUES_START';
export const DELETE_ENTITY_VALUES_SUCCESS = 'DELETE_ENTITY_VALUES_SUCCESS';
export const DELETE_ENTITY_VALUES_ERROR = 'DELETE_ENTITY_VALUES_ERROR';
